<template>
  <div class="playlist-group-view">
    <div class="header">
      <back-btn :canReturn="canReturn" :backRoute="homeRoute" :shouldPop="shouldPop" dark />
    </div>
    <playlist-group :playlistGroupId="playlistGroupId" :shouldAutoplay="shouldAutoplay" />
  </div>
</template>

<script>
import { HOME_ROUTE } from '@/router/utils'

let canReturn = false
let shouldPop = false
let shouldAutoplay = false

export default {
  name: 'playlistGroupView',
  computed: {
    playlistGroupId() {
      return this.$route.params.id
    },
    shouldPop() {
      return shouldPop
    },
    canReturn() {
      return canReturn
    },
    shouldAutoplay() {
      return shouldAutoplay
    },
    homeRoute() {
      return HOME_ROUTE
    }
  },
  beforeRouteEnter(to, from, next) {
    canReturn = !!from.name
    shouldPop = from.name === 'browse'
    shouldAutoplay = to.name === 'autoplay-video'
    next()
  }
}
</script>

<style lang="scss" scoped>
.playlist-group-view {
  .header {
    width: 100%;
    align-items: flex-start;
  }
}
</style>
